import clsx from "clsx";

import { Badge } from "@merge-api/merge-javascript-shared";
import {
  AdminCategory,
  abbreviationForAPICategory,
  colorForAPICategory,
} from "../../../models/Categories";
import useIntegrationBuilderContext from "../context/useIntegrationBuilderContext";

interface CategoryStatusBadgeProps {
  category: AdminCategory;
}

const SimpleCategoryCell = ({ category }: CategoryStatusBadgeProps) => {
  const categoryColor = colorForAPICategory(category); // Ensure this function is imported
  const categoryAbbreviation = abbreviationForAPICategory(category); // Ensure this function is imported
  const { markedForDeletion } = useIntegrationBuilderContext();

  return (
    <Badge className={clsx("items-center")} color={markedForDeletion ? "gray" : categoryColor}>
      {categoryAbbreviation}
    </Badge>
  );
};

export default SimpleCategoryCell;
